import React from "react";
import { Outlet } from "react-router-dom";

function PlotterIndexPage() {
  return <Outlet />
}

export { PlotterIndexPage };
